import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import "./GameWelcome.scss";
import kantoorBgJson from "../../../../assets/lottie/drACE_kantoor_BG.json"
import { useGameState } from "../../../../hooks/useGameState";
import praatAceJson from "../../../../assets/lottie/drACE_kantoor_Praat.json";
import { Player } from '@lottiefiles/react-lottie-player';

interface IProps {
    setRedAlert: Dispatch<SetStateAction<boolean>>
}

export function GameWelcome({
                                setRedAlert
                            }: IProps) {
    const { gameState, setGameState } = useGameState();
    const visible = ['welcome', 'intro', 'tutorial', 'game-over', 'win'].includes(gameState);
    const [render, setRender] = useState(true);

    const lottieSrc = gameState === 'welcome' ? praatAceJson : kantoorBgJson;

    const handleContinue = useCallback(() => {
        setRedAlert(true);
        setGameState('intro');
    }, [setRedAlert, setGameState]);


    // Set the red alert state after 10s of showing this screen
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (gameState === 'welcome') {
                handleContinue();
            }
        }, 13000);
        return () => {
            clearTimeout(timeout);
        }
    }, [gameState, handleContinue]);

    // Change rendering for a lottie src change
    useEffect(() => {
        setRender(false);
        setTimeout(() => {
            setRender(true);
        }, 10);
    }, [lottieSrc]);

    if (!render) return <></>;

    return (
        <div className={`game-welcome-wrapper ${visible ? 'visible' : ''} ${gameState === 'welcome' ? 'active' : ''}`} onClick={handleContinue}>
            <Player
                autoplay
                loop
                renderer={'canvas'}
                src={lottieSrc}
                style={{ width: '100%', height: '100%'}}
            ></Player>
        </div>
    )
}
